import isDevelopment from '@/helpers/is-development'
import DataLayer from '../data'

export default ({ debug, store, VueI18N }) => {
    return new Promise((resolve) => {
        debug && console.log('bootstrap.local', 'init');
        
        if ( isDevelopment() ){
            const dl = new DataLayer();
            dl.bootstrapLocal({ store })
            .then( (config) => {
                VueI18N.setConfig(config.i18n);
                debug && console.log('bootstrap.local', 'completed');
                resolve();
            })
        }
        else{
            debug && console.log('bootstrap.local', 'completed');
            resolve();
        }
    })
}